module.exports = __webpack_public_path__ + "img/bg.7163fe76.svg";